import styled, { keyframes } from "styled-components";
import theme from "../theme";

const shimmer = keyframes`
  0%   { background-position: -600px 0; }
  100% { background-position:  600px 0; }
`;

const Bone = styled.div`
  background: linear-gradient(
    90deg,
    ${theme.cardBorder} 25%,
    ${theme.bgAlt}      50%,
    ${theme.cardBorder} 75%
  );
  background-size: 600px 100%;
  animation: ${shimmer} 1.4s ease infinite;
  border-radius: ${(p) => p.$r || "6px"};
  width: ${(p) => p.$w || "100%"};
  height: ${(p) => p.$h || "12px"};
  flex-shrink: 0;
`;

const Card = styled.div`
  background: ${theme.cardBg};
  border-radius: 14px;
  border: 1.5px solid ${theme.cardBorder};
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const AuthorRow = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 14px 16px 10px;
`;

const Body = styled.div`
  padding: 0 16px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Footer = styled.div`
  padding: 10px 16px;
  border-top: 1px solid ${theme.separator};
  display: flex;
  gap: 12px;
`;

export default function NoteCardSkeleton() {
  return (
    <Card>
      {/* image placeholder */}
      <Bone $h="140px" $r="0" />

      <AuthorRow>
        <Bone $w="32px" $h="32px" $r="50%" />
        <Bone $w="90px" $h="11px" />
      </AuthorRow>

      <Body>
        <Bone $w="75%" $h="14px" />
        <Bone $w="55%" $h="14px" />
        <Bone $h="11px" />
        <Bone $w="80%" $h="11px" />
      </Body>

      <Footer>
        <Bone $w="36px" $h="11px" />
        <Bone $w="36px" $h="11px" />
        <Bone $w="36px" $h="11px" />
      </Footer>
    </Card>
  );
}
